import { render, staticRenderFns } from "./AvPlayerView.vue?vue&type=template&id=754556e6&scoped=true&"
import script from "./AvPlayerView.vue?vue&type=script&lang=js&"
export * from "./AvPlayerView.vue?vue&type=script&lang=js&"
import style0 from "./AvPlayerView.vue?vue&type=style&index=0&id=754556e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754556e6",
  null
  
)

export default component.exports